import { render, staticRenderFns } from "./PSTable.vue?vue&type=template&id=113cf03a&scoped=true&"
import script from "./PSTable.vue?vue&type=script&lang=js&"
export * from "./PSTable.vue?vue&type=script&lang=js&"
import style0 from "./PSTable.vue?vue&type=style&index=0&id=113cf03a&prod&lang=css&"
import style1 from "./PSTable.vue?vue&type=style&index=1&id=113cf03a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113cf03a",
  null
  
)

export default component.exports